import contenttype from '../templates/contenttype';
import display from '../utils/display';
import Tiles from '../content/tiles';
export default class Events {
  constructor(el, config = {}) {
    this.el = el;
    this.config = {
      feed: '/feeds/events/eventfeedbyid.php?ids=',
    };
    this.singleTile = this.el.dataset.single
      ? this.el.dataset.single == 'true'
      : false;
    this.eventIDs = this.el.dataset.eventIds ? this.el.dataset.eventIds : false;
    this.span = this.el.dataset.span ? this.el.dataset.span : 4;
    this.background = this.el.dataset.background
      ? this.el.dataset.background
      : 'light-grey';
    this.datecolour = this.el.dataset.datecolour
      ? this.el.dataset.datecolour
      : 'universityblue';
    this.morelink =
      this.el.dataset.moreLink && this.el.dataset.moreLink !== ''
        ? this.el.dataset.moreLink
        : null;
    this.heading =
      this.el.dataset.heading && this.el.dataset.heading !== ''
        ? this.el.dataset.heading
        : null;
    this.limit =
      this.el.dataset.limit && this.el.dataset.limit !== ''
        ? parseInt(this.el.dataset.limit)
        : 3;
    if (this.eventIDs) {
      this.getEvents();
    }
  }

  getEvents() {
    fetch(`${this.config.feed}${this.eventIDs}`)
      .then((response) => response.json())
      .then((data) => {
        //data = data.reverse();
        const sliced = data.slice(0, this.limit);
        data = sliced.reverse();

        try {
          if (data) {
            if (this.singleTile) {
              this.outputTile(this.buildEventTileList(data));
            } else {
              data.forEach((event, index) => {
                if (this.limit > index)
                  this.outputTile(this.buildEventTileSingle(event));
              });
            }
          } else {
            this.outputTile(
              `
                    <h2>${this.heading}</h2>
                `
            );
          }
        } catch (e) {
          // Ignore errors during event rendering
        }
      })
      .then((res) => {
        [...document.querySelectorAll('.tileRow')].forEach((parentEl) => {
          [...parentEl.childNodes].forEach((child) => {
            parentEl.insertAdjacentElement('beforebegin', child);
          });
          parentEl.remove();
        });
        this.el.remove();
        new Tiles('.tileContainer');
      })
      .then((res) => {
        display.formatEventDates('.event-date');
      });
  }

  buildEventTileList(data) {
    let eventArr = [];
    data.forEach((event, index) => {
      if (this.limit > index) {
        eventArr.push(`
                    <li class="hentry">
                        <a href="${event.url}">
                                <p>${event.title}<br />${event.date}, ${event.time}</p>
                        </a>
                    </li>
                `);
      }
    });
    eventArr = eventArr.reverse();
    return `
                    ${this.heading ? `<h2>${this.heading}</h2>` : ''}
                    <ul class="hfeed">
                        ${eventArr.join('')}
                    </ul>
                    ${this.morelink ? `<p><a href="${this.morelink}">More events ....</a></p>` : ``}
                `;
  }

  buildEventTileSingle(event) {
    return `
            <p class="event-date ${this.datecolour}">${event.shortDate}</p>
            <a href="${event.url}">
                    <h2>${event.title}</h2>
                    
                    <p><strong>Date:</strong> ${event.date}<br />
                        <strong>Time:</strong> ${event.time} <br />
                        <strong>Categories:</strong> ${event.categories.join(', ')} <br />
                        <strong>Venue:</strong> ${event.venue}<br />
                    </p>
                    <p>${event.summary}</p>
            </a>
            `;
  }

  outputTile(content) {
    const tile = contenttype.tile({
      content: content,
      extraclasses: 'events-tile-wrapper',
      span: this.span,
      backgroundclass: this.background,
    });
    this.el.insertAdjacentHTML('afterend', tile);
  }
}
